import { UserRole } from 'shared/types/userRole';
import { PermissionManagerFactory } from '../permissionManagerFactory';
import { Permission, PermissionConfig } from '../types';
import { allow, forbid } from '../basePermissionsManager';

interface InspectionEditParams {
  isCompleted: boolean;
  deleted?: boolean;
}

interface InspectionCreateParams {
  isInspectionTemplatePublished: boolean;
  isInspectionTemplateArchived?: boolean;
}

interface InspectionDeleteParams {
  deleted?: boolean;
}

function forbidToStartInspectionIfTemplateIsNotPublished({
  isInspectionTemplatePublished,
}: InspectionCreateParams): Permission {
  if (!isInspectionTemplatePublished) {
    return forbid('snack_start_inspection_on_published_template_error');
  }
  return allow();
}

function forbidToStartInspectionIfTemplateArchived({
  isInspectionTemplateArchived,
}: InspectionCreateParams): Permission {
  if (isInspectionTemplateArchived) {
    return forbid('inspection_start_on_archived_template_warning');
  }
  return allow();
}

function forbidToEditIfArchived({
  deleted,
}: InspectionEditParams): Permission {
  if (deleted) {
    return forbid('inspection_edit_on_archived_warning');
  }
  return allow();
}

export const INSPECTION_CRUD_PERMISSIONS: PermissionConfig = {
  [UserRole.superAdmin]: true,
  [UserRole.organizationAdmin]: true,
  [UserRole.projectAdmin]: true,
  [UserRole.manager]: true,
  [UserRole.viewer]: false,
  [UserRole.standard]: false,
  [UserRole.visible_no_access]: false,
};

export const InspectionPermissionManager = PermissionManagerFactory.create<
  InspectionCreateParams,
  InspectionEditParams,
  InspectionDeleteParams
>({
  permissionConfigForCreate: INSPECTION_CRUD_PERMISSIONS,
  permissionConfigForEdit: INSPECTION_CRUD_PERMISSIONS,
  permissionConfigForDelete: INSPECTION_CRUD_PERMISSIONS,
  businessRulesForEdit: [forbidToEditIfArchived],
  businessRulesForCreate: [
    forbidToStartInspectionIfTemplateIsNotPublished,
    forbidToStartInspectionIfTemplateArchived,
  ],
});
